<template>
  <div class="modal fade" :id="modalId">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">

        <!-- Popup header -->
        <v-toolbar color="elevation-0">
          <v-toolbar-title>
           <h3 id="myModalLabel">
           Content Analysis
          </h3>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon data-dismiss="modal">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <!-- Popup content -->
        <v-container container--fluid>
          <v-layout wrap>
            <v-flex xs12 md6>
              <v-card class='elevation-5'>
                <div v-html="igPost"></div>
              </v-card>
            </v-flex>
            <v-flex xs12 md6>
            <v-layout column>
            <v-flex xs12>
              <v-card class='elevation-5'>
                <v-card-text>
                  <p class="title text-center">
                    NLU (Natural Language Understanding) Result
                  </p>
                  <p class="subtitle-1 font-weight-bold">
                    Concepts
                  </p>
                  <p v-if="concepts.length <= 0" class="font-italic">
                    No Data
                  </p>
                  <p>
                    <v-chip v-for="content in concepts" :key="content.id">{{content.text}}</v-chip>
                  </p>
                  <p class="subtitle-1 font-weight-bold">
                    Sentiment
                  </p>
                  <p>
                   <span id="nlu_sentiment_label" class="text-capitalize">Positive</span> score of
                   <span id="nlu_sentiment_score" v-bind:style="sentimentScoreCss">{{sentiment}}</span>
                  </p>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12>
              <v-card class='elevation-5'>
                <v-card-text>
                  <p class="title text-center">
                    Image Recognition Result
                  </p>
                  <b-table striped bordered hover responsive 
                    :items="imageProcessingPagging.items" 
                    :fields="imageProcessingFields">
                  </b-table>
                  <div class="row">
                    <b-pagination :total-rows="imageProcessingPagging.totalRows" :per-page="imageProcessingPagging.perPage" v-model="imageProcessingPagging.currentPage" size="sm" align="center" />
                  </div>
                </v-card-text>
              </v-card>
            </v-flex>
            </v-layout>
            </v-flex>
          </v-layout>
        </v-container>

        <!-- Footer -->
        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal" ref="closeButton">OK</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import analysisAPI from './contentAnalysisAPI'
export default {
  name: 'ContentAnalysisResultModal',
  props: [
    'modalId',
    'postData'
  ],
  data() {
    return {
      imageProcessingData: [],
      nluProcessingData: [],
      imageRecognitionResultsTable: [],
      concepts: [],
      sentimentScoreCss: {},
      sentiment: '+60.57',
      shortCode: null,
      igPost: null,
      imageProcessingFields: [
        {
          key: 'Tags',
          sortable: true
        },
        {
          key: 'Value',
          sortable: true
        }
      ],
      imageProcessingPagging: {
        totalRows: 0,
        perPage: 10,
        currentPage: 1,
        items: []
      }
    }
  },
  watch: {
    postData: function (newPostData) {
      this.shortCode = newPostData.short_code
      this.nluProcessingData = newPostData.nlu_processing_data
      this.imageProcessingData = newPostData.image_processing_data
      this.imageProcessingData.sort((a, b) => b.value - a.value)
      this.imageRecognitionResultsTable = [] // reset the table
      this.imageProcessingData.forEach((item) => {
        this.imageRecognitionResultsTable.push({
          Value: (item.value * 100).toFixed(2) + '%',
          Tags: item.name
        })
      })
      // Display concepts
      if (this.nluProcessingData.concepts) {
        this.concepts = []
        this.concepts = this.nluProcessingData.concepts
      }

      // Display sentiment
      if (this.nluProcessingData.sentiment) {
        let sentimentScore = (this.nluProcessingData.sentiment.score * 100).toFixed(2)
        this.sentiment = sentimentScore + '%'
        if (sentimentScore > 0) {
          this.sentiment = '+' + this.sentiment
        }
        if (sentimentScore < -0.5) {
          this.sentimentScoreCss = { 'color': 'red' }
        } else if (sentimentScore < -0) {
          this.sentimentScoreCss = { 'color': 'orange' }
        } else if (sentimentScore < 0.5) {
          this.sentimentScoreCss = { 'color': '#ffd400' }
        } else {
          this.sentimentScoreCss = { 'color': 'green' }
        }
      }
      this.imageProcessingPagging.totalRows = this.imageProcessingData.length
      this.paginateImageProcessing()
      this.getInstagramPost()
    },
    'imageProcessingPagging.currentPage': function(currentPage) {
      this.paginateImageProcessing()
    }
  },
  methods: {
    paginateImageProcessing: function() {
      let start = (this.imageProcessingPagging.currentPage - 1) * this.imageProcessingPagging.perPage
      let end = start + this.imageProcessingPagging.perPage
      this.imageProcessingPagging.items = this.imageRecognitionResultsTable.slice(start, end)
    },
    getInstagramPost: function() {
      analysisAPI.oembed(this.shortCode).then((data) => {
        this.igPost = data.oembed
        setTimeout(() => {
          window.instgrm.Embeds.process()
        }, 100)
      }).catch(() => {
        this.igPost = ''
      })
    }
  }
}
</script>

<style>
.filter {
  padding: 5px;
  width: 180px;
  border: 1px solid gray;
  border-radius: 6px;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// ContentAnalysisResultModal.vue?0584c30c